var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchange = function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B4BCD0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M16.977 19.5A9 9 0 0 0 10 3.223M16.977 19.5V16m0 3.5H20.5M7 4.516a9 9 0 0 0 7 16.26M7 4.517V8m0-3.484H3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4BCD0",
    fillRule: "evenodd",
    d: "M12.391 12.05v2.75c.918-.087 1.305-.629 1.305-1.345 0-.69-.3-1.097-1.305-1.405m-.782-1.375V8.2c-.854.114-1.305.64-1.305 1.218s.356 1.003 1.305 1.257m.74.203.28.076C14.161 11.34 15 12.027 15 13.38c0 1.556-1.165 2.439-2.65 2.553V17h-.659v-1.067c-1.48-.12-2.65-1.029-2.691-2.553h1.206c.105.743.548 1.29 1.485 1.397v-2.768l-.239-.064c-1.48-.375-2.277-1.099-2.277-2.388 0-1.423 1.048-2.363 2.516-2.483V6h.659v1.073c1.456.127 2.51 1.08 2.557 2.522h-1.212c-.075-.8-.6-1.264-1.345-1.366z",
    clipRule: "evenodd"
  })));
};
export default SvgExchange;